/**
 * The type of field to be used
 */
export enum FieldType {
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  SINGLE_SELECT = 'SINGLE-SELECT',
  ENTITY = 'ENTITY',
  DATE = 'DATE',
}

/**
 * The Entity Type the field relates to
 */
export enum FieldEntityType {
  COMPANY = 'COMPANY',
  CONTACT = 'CONTACT',
}
